// Lib
import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';

import type { SocialProfileType } from '@/types/socialProfileType';

import { availableNetwork } from '@/lib/scheduler/config/availableNetwork';

type UseGetSchedulerFunnelProfilesIdParams = {
    activeSocialProfile: SocialProfileType;
    activeGroup: SpGroupType;
};

export function useGetSchedulerFunnelProfilesId({
    activeSocialProfile,
    activeGroup
}: UseGetSchedulerFunnelProfilesIdParams) {
    if (activeSocialProfile) {
        const hasPermission = activeSocialProfile.permissions.includes('scheduler');
        const isAvailableNetwork = availableNetwork.some(
            (network) => network === activeSocialProfile.social_network_type
        );

        if (!isAvailableNetwork) {
            return {
                profilesId: [],
                profilesIdWithPermission: []
            };
        }

        return {
            profilesId: [activeSocialProfile.id],
            profilesIdWithPermission: hasPermission ? [activeSocialProfile.id] : []
        };
    }

    const groupSocialProfiles =
        activeGroup?.social_profiles.filter((profile) => {
            return (
                availableNetwork.some((network) => network === profile.social_network_type) &&
                profile.active
            );
        }) ?? [];

    return {
        profilesId: groupSocialProfiles.map(({ id }) => id),
        profilesIdWithPermission: groupSocialProfiles
            .filter((profile) => {
                return profile.permissions.includes('scheduler');
            })
            .map(({ id }) => id)
    };
}
